module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/favicon_ohiolink_2_80b3da4.png";